import { FiArrowUpRight } from 'react-icons/fi'
import { Container, Reveal, RevealGroup } from '@/components/common'
import type { Issue } from '@/types/magazine'
import { issues } from '@/constants/magazine'

const IssueCard = ({ title, edition, date, image }: Issue) => (
  <article className="group">
    <a href={image} target="_blank" rel="noopener noreferrer" className="block">
      <div className="relative overflow-hidden">
        <img
          src={image}
          alt={`${title}, ${edition}`}
          className="aspect-4/5 w-full object-cover transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-ibon-dark/0 transition-colors duration-500 group-hover:bg-ibon-dark/30" />
        <span className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-white text-ibon-dark opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <FiArrowUpRight size={18} />
        </span>
      </div>
    </a>
    <div className="mt-5 flex items-center justify-between gap-3">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-ibon-sky">{edition}</p>
      <p className="text-xs font-medium uppercase tracking-[0.15em] text-text-muted">{date}</p>
    </div>
    <h3 className="mt-2 text-xl font-bold leading-snug tracking-tight text-ibon-dark">{title}</h3>
  </article>
)

export const MagazineArchive = () => {
  return (
    <section id="archive" className="scroll-mt-24 bg-surface py-24 lg:py-32">
      <Container>
        <div className="max-w-3xl">
          <Reveal variant="up" delay={100}>
            <h2 className="mt-7 text-4xl font-bold leading-[1.05] tracking-[-0.02em] text-ibon-dark sm:text-5xl lg:text-6xl">
              Explore past <span className="text-ibon-dark/30">editions.</span>
            </h2>
          </Reveal>
          <Reveal variant="up" delay={200}>
            <p className="mt-6 text-lg leading-relaxed text-text-muted">
              Browse our growing library of stories, interviews, and insights from across Africa and
              the Caribbean.
            </p>
          </Reveal>
        </div>

        <RevealGroup
          className="mt-16 grid grid-cols-2 gap-x-6 gap-y-14 sm:grid-cols-3 lg:grid-cols-3"
          step={80}
        >
          {issues.map((issue) => (
            <IssueCard key={issue.edition} {...issue} />
          ))}
        </RevealGroup>
      </Container>
    </section>
  )
}
